var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value === 'checking')?_c('div',[_c('b-spinner',{attrs:{"type":"grow"}})],1):_vm._e(),(_vm.value === 'exists')?_c('div',[_vm._m(0)]):_vm._e(),(_vm.value === 'new')?_c('div',[_vm._m(1)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('b',[_c('span',{staticClass:"dot bg-secondary"}),_vm._v(" Exist ")])
},function (){var _vm=this,_c=_vm._self._c;return _c('b',[_c('span',{staticClass:"dot bg-info"}),_vm._v(" New ")])
}]

export { render, staticRenderFns }